import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { IncomingCallBannerComponent } from './features/telephonie/incoming-call-banner.component';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, IncomingCallBannerComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './app.component.html',
})
export class AppComponent {}
